export default "__VITE_ASSET__DJwDOEXL__"